import React from 'react'
import Structure from '../components/layout/Structure'

const Contact = () => {
  return (
    <Structure>
      CONTACT
    </Structure>
  )
}

export default Contact